/* eslint-disable no-invalid-this */
/* eslint-disable new-cap */
import {html} from 'lit';
import {classMap} from 'lit/directives/class-map.js';
import {FacetBasic} from '../facet-basic/facet-basic';
import styles from './facet-setting-metal.component.scss?as=stylesheet';
import {defineCustomElement} from 'extensions/utils';

class FacetSettingMetal extends FacetBasic {

	static get styles () {
		return [
			...super.styles,
			styles
		];
	}

	constructor () {
		super();
	}

	renderFacetValues () {
		return html`
			<div class="facet-values">
				${this.facet?.values?.map(facetValue => html`
					<div class="facet--value">
						${this.renderMetalFacet(facetValue)}
					</div>`)
				}
			</div>
		`;
	}

	/**
	 * @param {import('extensions/hawksearch/services/types').FacetValue} facetValue
	 */
	renderMetalFacet (facetValue) {
		const classes = {
			'facet--value-active': facetValue.selected,
			'facet--value-link': true
		};

		return html`
			<a class="${classMap(classes)}" @click="${() => this.service.toggleFacetValue(this.facet.field, facetValue.value)}">
				<span class="facet-swatch facet-swatch--${this.getMetal(facetValue.value)}" aria-hidden="true"></span>
				<span class="facet-label">${facetValue.title}</span>
			</a>
		`;
	}

	getMetal (value) {
		return value?.toLowerCase()?.replace(/ /g, '-').replace(/&/g, '');
	}
};

defineCustomElement('rb-facet-setting-metal', FacetSettingMetal);
